import { Injectable } from '@angular/core';
import { INodeInstanceModel } from '../../models/node/node-instance.model';
import { ITreeNode } from '../../models/project/project.model';

@Injectable({
  providedIn: 'root',
})
export class LabelTreeHelper {
  constructor() {}

  public getNodesTreePathById(nodesTree: ITreeNode[], id: string, separator: string = '/'): string {
    if (!nodesTree) return '';
    let resultPath = '';

    //helper function to reset to previous path if current node +esn't contain the target id
    const getPreviousPath = (pathString: string) => {
      let pathArr = pathString.split('/');
      return pathArr.slice(0, pathArr.length - 1).join('/');
    };
    let path = '';
    // utility recursive function to search through nodeTree with the node id
    const getNodePathById = (node: INodeInstanceModel) => {
      path = path + '/' + node.name;
      if (node.id === id) {
        resultPath = path.slice(1);
        return;
      }
      if (node.childNodes?.length && node.childNodes?.length > 0) {
        node?.childNodes?.forEach((childNode) => {
          getNodePathById(childNode);
          path = getPreviousPath(path);
        });
      }
    };

    const getNodeTreePathById = (node: ITreeNode) => {
      path = path + '/' + node.name;
      if (node.id === id) {
        resultPath = path.slice(1);
        return;
      }
      if (node.children?.length && node.children?.length > 0) {
        node?.children?.forEach((childNode) => {
          getNodeTreePathById(childNode);
          path = getPreviousPath(path);
        });
      }
    };
    nodesTree.forEach((nodeEle) => {
      path = '';
      getNodeTreePathById(nodeEle);
    });
    // '/' is only the internal delimiter used while walking/backtracking above - swap it for the
    // requested display separator once the final path is resolved.
    return separator === '/' || !resultPath ? resultPath : resultPath.split('/').join(separator);
  }
}
